var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDisableImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.48205 2.3103L1.54935 9.2435C1.51447 9.27848 1.48929 9.32265 1.47729 9.37012L0.708871 12.4544C0.685885 12.5473 0.713168 12.646 0.780926 12.7137C0.832194 12.765 0.902051 12.7934 0.973506 12.7934C0.995393 12.7934 1.01778 12.7907 1.03957 12.7852L4.12385 12.0167C4.17192 12.0047 4.2156 11.9796 4.25047 11.9447L11.1838 5.01203L8.48205 2.3103Z",
    fill: "#969BA9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8996 1.36491L12.1278 0.593191C11.6121 0.0774106 10.7131 0.0779103 10.1979 0.593191L9.25262 1.5385L11.9542 4.24013L12.8996 3.29481C13.1572 3.03727 13.2991 2.69449 13.2991 2.32991C13.2991 1.96534 13.1572 1.62255 12.8996 1.36491Z",
    fill: "#969BA9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisableImg);
export default __webpack_public_path__ + "static/media/disableImg.0697914bff4cdcebfc1a30f253cdec23.svg";
export { ForwardRef as ReactComponent };